import { SeedTicket } from 'constants/interface';
import { buildRegularProductDisplay, buildSimpleQuantityDisplay } from 'helpers/order';
import React from 'react';
import {
  Modal,
} from 'UI';
import { formatStringDate } from 'helpers/utils';

import {
  InlineButton,
  MainContainer,
  ItemInfoContainer,
  ItemInfoRow,
  ItemInfoLabel,
  ItemInfoValue,
} from './style';

interface ConfirmTicketModalProps {
  item?: SeedTicket
  isVisible: boolean
  onCancel: () => void
}

const TicketDetailsModal = ({
  item,
  isVisible,
  onCancel,
}: ConfirmTicketModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={`Solicitação Nº ${item?.seq || ''}`}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Fechar
      </InlineButton>,
      // <InlineButton
      //   key="submit"
      //   onClick={confirmSeedTicket}
      //   disabled={isLoading}
      //   loading={isLoading}
      // >
      //   Salvar
      // </InlineButton>,
    ]}
  >
    <MainContainer>
      {/* Request Info */}
      <ItemInfoContainer>
        <ItemInfoRow>
          <ItemInfoLabel>Cliente:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.productionItem.orderItem.order.client.name || ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Cultivar:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? buildRegularProductDisplay(item.productionItem, {
              quantity: false,
              tray: false,
            }) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Quantidade prevista:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? buildSimpleQuantityDisplay(item.requestQuantity) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Unidade:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? item.productionItem.orderItem.order.organization.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Data da solicitação:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? formatStringDate(item.createdAt) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Solicitante:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? item.createdBy.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
      </ItemInfoContainer>

      {/* Confirmation Info */}
      <ItemInfoContainer>
        <ItemInfoRow>
          <ItemInfoLabel>Data da compra:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.purchaseDate ? formatStringDate(item.purchaseDate) : ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Fornecedor:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.provider || ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Quantidade solicitada:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.purchaseQuantity ? buildSimpleQuantityDisplay(item.purchaseQuantity) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Previsão de entrega:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.estimatedReceivingDate ? formatStringDate(item.estimatedReceivingDate) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Comprador:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.purchasedBy ? item.purchasedBy.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
      </ItemInfoContainer>

      {/* Closing Info */}
      <ItemInfoContainer>
        <ItemInfoRow>
          <ItemInfoLabel>Data de confirmação:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.closedAt ? formatStringDate(item.closedAt) : ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Responsável:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.closedBy?.name || ''}`}</ItemInfoValue>
        </ItemInfoRow>
      </ItemInfoContainer>
    </MainContainer>
  </Modal>
);

export default TicketDetailsModal;
